module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"chartHeaderTooltip":"he ranking by the number of available offers in stores for the product."}}')
  delete Component.options._Ctor
}
